import { HTTP } from "@/utils/http-common"
import axios from "axios"
import config from "@/app.config"
import store from "@/store"

export default {
  async getAll($, filters = {}) {
    const path = `/activity/make/payment`
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${path}?${queryParams}` : path;

    let results = (await HTTP.get(url)).data

    return results
  },

  async getFidelities($, filters = {}) {
    const path = `/activity/fidelity/histories`
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${path}?${queryParams}` : path;

    let results = (await HTTP.get(url)).data

    return results
  },

  async exportExcel(filters = {}) {
    const path = `/activity/make/payment/export`
    const queryParams = new URLSearchParams(filters).toString()
    const url = queryParams ? `${path}?${queryParams}` : path
    const baseURL = config.general.api
    const token = store.state.app.user ? store.state.app.user.key : null
    const headers = {}
    if (token) headers.authorization = "Token " + token
    const response = await axios.get(baseURL + url, {
      responseType: 'blob',
      headers,
    })
    return response.data
  },

  async exportStation(filters = {}) {
    const path = `/activity/make/payment/export-station`
    const queryParams = new URLSearchParams(filters).toString()
    const url = queryParams ? `${path}?${queryParams}` : path
    const baseURL = config.general.api
    const token = store.state.app.user ? store.state.app.user.key : null
    const headers = {}
    if (token) headers.authorization = "Token " + token
    const response = await axios.get(baseURL + url, {
      responseType: 'blob',
      headers,
    })
    return response.data
  },

  async get(actionId) {
    const path = `/activity/make/payment/${actionId}`
    return (await HTTP.get(path)).data
  }
}
